import * as React from "react"
import PropTypes from "prop-types"
import {
  convertToWebp,
  transformImage,
} from "../../../helpers/ImageHelper"
import { TABLET_BREAKPOINT , DESKTOP_BREAKPOINT } from "../../../constants/mediabreakpoint.constants";

const MondelezeImage = props => {
  const {
    src,
    desktopScreenUrl,
    mobileScreenUrl,
    className,
    alt,
    additionalParams,
    onClick = () => undefined,
    width = undefined,
    height = undefined,
    eventClass = '',
    eventLabel,
    isLazy = false
  } = props

  if (!src && !desktopScreenUrl && !mobileScreenUrl) return null

  const classNameFinal = [className, eventClass].join(" ")

  // get Image url 
  const getUrl = (src,additionalParams,desktopScreenUrl,mobileScreenUrl) => {
    if(src){
      return(transformImage(src,additionalParams));
    }else if(desktopScreenUrl){
      return(transformImage(desktopScreenUrl,additionalParams));
    }else if(mobileScreenUrl){
      return(transformImage(mobileScreenUrl,additionalParams));
    }else{
      return ''
    }
  }

  // assign src, alt, w, h from either contentful Image object or direct params passed
  const imgSrc = getUrl(src,additionalParams,desktopScreenUrl,mobileScreenUrl);
  const imgAlt = alt || "";
  const imgW = width || "auto";
  const imgH = height || "auto";

  return (
        <picture>
          {desktopScreenUrl ? <source media={`(min-width:${DESKTOP_BREAKPOINT}px)`} srcSet={convertToWebp(desktopScreenUrl)}/> : <></>} 
          {mobileScreenUrl ? <source media={`(max-width:${TABLET_BREAKPOINT}px)`} srcSet={convertToWebp(mobileScreenUrl)}/>  : <></> }
          <img
              role="presentation" // for accessibility
              src={convertToWebp(imgSrc)}
              loading={isLazy?'lazy':'eager'}
              alt={imgAlt}
              className={classNameFinal}
              onClick={onClick}
              width={imgW}
              height={imgH}
              data-action-detail={eventLabel}
          />
        </picture>
  )
}

export default React.memo(MondelezeImage);

MondelezeImage.propTypes = {
  src: PropTypes.string,
  desktopScreenUrl : PropTypes.string,
  mobileScreenUrl : PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  additionalParams: PropTypes.object,
  onClick: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  eventClass: PropTypes.string,
  eventLabel: PropTypes.string,
  isLazy : PropTypes.bool,
}